import React from "react";
import { useSelector } from "react-redux";

import Plus18 from "../assets/images/icons/18plus.webp";
import Secure from "../assets/images/icons/secure.png";
import GameCare from "../assets/images/icons/gamecare.webp";
import GT from "../assets/images/icons/gt.png";

const Footer = () => {
  const { appDetails } = useSelector((state) => state.app);

  return (
    <>
      <footer className="footer">
        <div className="footer-links">
          <ul>
            <li>
              <a href="/contact">Contact Us</a>
            </li>
            <li>
              <a href="/privacypolicy">Privacy Policy</a>
            </li>

            <li>
              <a href="/ResponsibleGaming">Responsible Gaming</a>
            </li>
            <li>
              <a href="/fairplay">Fair Play</a>
            </li>
            <li>
              <a href="/gamerules">Games Rules</a>
            </li>
            <li>
              <a href="/termsandcondition">Terms and Conditions</a>
            </li>
          </ul>
          <div className="Support">24X7 Support</div>
        </div>

        <div className="LicenseSection">
          <div className="LicenseImg">
            <img src={Secure} alt="Secure" />
            <div className="LicenseContent">
              <h3>100% SAFE</h3>
              <p>Protected connection and encrypted data.</p>
            </div>
          </div>
          <div className="SecureImg">
            <ul>
              <li>
                <img src={Plus18} alt="Plus18" />
              </li>
              <li>
                <img src={GameCare} alt="GameCare" />
              </li>
              <li>
                <img src={GT} alt="GT" />
              </li>
            </ul>
          </div>
        </div>

        <div className="copyright">
          © Copyright 2025. All Rights Reserved. Powered by kismatbets.
        </div>
      </footer>
    </>
  );
};

export default Footer;
